import { Recommendation } from "./types";

export const Recommendations: Recommendation[] = [
  {
    name: "Jauhari Alafi",
    jd: "Full-Stack Developer",
    image: "/images/jau.jpeg",
    recommendation:
      "Ogaga is a great developer who is always eager to learn and improve. He communicates well, shares ideas openly, and brings a positive, appreciative attitude to team collaboration.",
  },
  {
    name: "Roland Ossisa Yuma",
    jd: "Full-Stack Developer",
    image: "/images/roland.jpeg",
    recommendation:
      "I worked remotely with Ogaga on a React project. His technical and soft skills made pair programming enjoyable, and I admired his determination to find solutions whenever we faced blockers.",
  },
  {
    name: "Hamed Adisa",
    jd: "Full-Stack Developer",
    image: "/images/hamed.jpeg",
    recommendation:
      "Ogaga is a self-taught software engineer with a strong passion for project development. He is eager to learn, improves consistently, and would be a good fit for product-focused teams.",
  },
];
